import { apiGetHelper } from '../../helperFunctions'

export interface HotelDestinationPayload {
    uniqueId: string
    cityId?: string
    provinceName?: string
    provinceId?: string
    cityName?: string
    hotelName?: string
    countryName?: string
    countryCode?: string
    countryId?: string
    latitude?: string
    longitude?: string
    misspelled?: string
    [key: string]: any
}

export interface HotelDestinationApiItem {
    text: string
    score: number
    payload: HotelDestinationPayload
}

export interface HotelDestinationApiResponse {
    cities?: HotelDestinationApiItem[]
    hotels?: HotelDestinationApiItem[]
    airports?: any[]
}

/**
 * Same-origin: this service runs on every domain the app is served from, so the
 * request stays on whichever host the user is already on.
 */
export const searchHotelDestinations = async (query: string): Promise<HotelDestinationApiResponse> => {
    try {
        const encoded = encodeURIComponent(query)
        const response = await apiGetHelper({
            URL: `/psh/${encoded}?q=${encoded}`,
            deviceType: 'DESKTOP'
        })
        return (response as any).data || {}
    } catch (error) {
        console.error('Error searching hotel destinations:', error)
        return {}
    }
}
